/**
 * @module client
 *
 */

export function shouldRedirect(frame: Window): boolean {
  return frame === window;
}

export function redirect(url: string) {
  window.location.assign(url);
}

export function getLocation() {
  return window.location;
}



// WEBPACK FOOTER //
// ./src/client/redirect.ts